var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(-274 -407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(274 407)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,15.58V18.5H7.416l8.6-8.6L13.1,6.979ZM18.273,7.64a.774.774,0,0,0,0-1.1l-1.82-1.82a.774.774,0,0,0-1.1,0L13.933,6.147l2.916,2.916Z",
    transform: "translate(279.5 412.504)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1ac0b5ec2379b99b5f1df15161dc8015.svg";
export { ForwardRef as ReactComponent };